
import TitleBox from '@/components/CSS/TitleBox'
import NumberVerify from '@/components/NumberVerify'
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
export default {
    components: {
        TitleBox,
        NumberVerify
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            userAccount: 'user/userAccount',
            userAccountAlipay: 'user/userAccountAlipay'
        })
    },
    data() {
        return {
            ruleFrom: {},
            rules: {},
            dialogVisible: false,
            loading: false,
            radio: '1'
        }
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        isRealName() {
            if (!this.userinfo.isRealName) {
                this.$confirm('完成实名认证后再进行添加账户，是否前往？', '提示', {
                    confirmButtonText: '立即前往',
                    confirmButtonClass: 'confirmButtonClass',
                    type: 'error'
                })
                    .then(() => {
                        // window.localStorage.setItem("realPath", this.$route.path);
                        this.$router.push('/account/authHome')
                    })
                    .catch((_) => {})
                return
            }
            this.$router.push('/account/addTiXianAccount')
        },
        completed(v) {
            if (v.length === this.$enum.payPassLength) {
                let p = {
                    action: {
                        payPassword: md5(v)
                    }
                }
                this.loading = true
                this.$api.unbindAlipay(p).then((res) => {
                    this.loading = false
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.dialogVisible = false
                    this.$store.dispatch('user/UserAccountAlipay')
                    this.$message.success(res.info)
                })
            }
        }
    },
    mounted() {
        this.$store.dispatch('user/UserGetInfo')
        this.$store.dispatch('user/UserAccountAlipay')
    }
}
